import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CORGI_SSR_CACHE = createFcmDetails('corgi_ssr_cache', {
	owner: 'FE framework squad',
	context: 'corgi SSR',
	description: `Used to enable corgi SSR server caching.
			"default" is used to indicate that server caching should be enabled by default on routes that support it.
			Other properties should match the route's id in corgi, and are used to override that default behavior.`,
	template: {
		default: true,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		'route-id': false,
	},
	import: false,
});
